<ion-card class="ion-text-center nonbooking-card">
    <ion-card-header class="card-header-starttime">
        <ion-card-title class="ion-text-center">
            <div class="application-starttime bold-text">
                {{ status?.application?.type }}<br />
                {{ status?.application?.startdate | date: 'longDate':'UTC' }} - {{ status?.application?.enddate | date: 'longDate':'UTC' }}
            </div>
        </ion-card-title>
    </ion-card-header>
    <ion-card-content>
        <div *ngIf="lastminute">
            <ion-item lines="none">
                <ion-icon class="icon" name="alert" slot="start" color="primary"></ion-icon>
                <ion-label class="bold-text card-text ion-text-wrap">You have chosen a last-minute rotation.</ion-label>
            </ion-item>
        </div>
        <div *ngIf="preapproval">
            <ion-item lines="none">
                <ion-icon class="icon" name="alert" slot="start" color="primary"></ion-icon>
                <ion-label class="bold-text card-text ion-text-wrap"
                    >This program requires additional approval. Please email
                    <a class="link-anchor-base" href="mailto:advisors@amopportunities.org?subject=Pre-approval Application" target="_blank"
                        >advisors&#64;amopportunities.org</a
                    >.
                </ion-label>
            </ion-item>
        </div>
    </ion-card-content>
</ion-card>
